import Link from 'gatsby-link';
import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { containers } from 'style';
import ThoughtCardImageComponent, {
    ThoughtCardImageWrapper,
} from './thoughtCardImage.component';
import ThoughtDetailsComponent from './thoughtDetails.component';

const ThoughtCardComponent = ({
    title,
    image,
    date,
    slug,
    timeToRead,
    even,
}) => {
    var date2 = new Date().getTime();
    var date1 = new Date(date).getTime();

    var diff = date2 - date1;

    var minutes = diff / 1000 / 60;
    var hours = minutes / 60;
    var days = hours / 24;

    let dateString = date;
    if (days < 365) {
        dateString = dateString.split('.')[0] + '.';
    }
    return (
        <ThoughtCard
            data-cursor="focus"
            data-cursor-persistance="200"
            className={even ? 'even' : 'odd'}>
            <Link to={`/news/${slug}`}>
                <ThoughtCardImageComponent image={image} />
                <div className="teaserDetailsWrapper">
                    <ThoughtDetailsComponent
                        date={dateString}
                        readTime={timeToRead}
                        css={ThoughtDetailsComponent_css}
                    />
                    <Title>{title}</Title>
                </div>
            </Link>
        </ThoughtCard>
    );
};

const ThoughtCard = styled.div`
    div::before {
        padding-top: 80%;
    }
    img {
        transition: opacity 0.5s, all 2s !important;
    }
    a {
        text-decoration: none;
        &:hover {
            ${ThoughtCardImageWrapper} {
                img {
                    transform: scale(1.05);
                }
            }
        }
    }
    &.even .teaserDetailsWrapper {
        padding-left: 5.5vw;
    }
    .teaserDetailsWrapper {
        margin-top: 1.6153846153846154rem;

        @media (min-width: ${containers.medium}px) {
            padding: 0 !important;
        }
    }
`;

const ThoughtDetailsComponent_css = css`
    /* margin-bottom: 1px; */
`;
const Title = styled.h3``;

export default ThoughtCardComponent;
